export enum Scope {
  Directory = 'directory',
  DirectoryData = 'directory-data',
  Module = 'module',
  Process = 'process',
  Standard = 'standard',
  Task = 'task',
  TaskData = 'task-data',
  Document = 'document',
  Tutorial = 'tutorial',
  Notification = 'notification',
  Handbook = 'handbook',
  WorkInstruction = 'work-instruction',
  DropdownConfig = 'dropdown-config',
  Help = 'help',
  Workspace = 'workspace',
  User = 'user',
  Datasheet = 'datasheet'
}
